<template>
  <v-container fluid pa-0 id="about-top">
    <sec-about-company></sec-about-company>
    <sec-diagonal v-model="this.$diagonal.bottom"></sec-diagonal>
    <sec-about-contacts></sec-about-contacts>
    <sec-request-demo></sec-request-demo>
    <sec-diagonal v-model="this.$diagonal.top"></sec-diagonal>
  </v-container>
</template>

<script>
import SecAboutCompany from '@/components/pages/public/SecAboutCompany';
import SecAboutContacts from '@/components/pages/public/SecAboutContacts';
import SecRequestDemo from '@/components/pages/public/SecRequestDemo';
import SecDiagonal from '@/components/pages/public/SecDiagonal';

export default {
  name: "About",
  components: {
    SecAboutCompany,
    SecAboutContacts,
    SecRequestDemo,
    SecDiagonal
  },
};
</script>
